import { customerCanChangeNumberOfVariations } from 'src/data/accessRights';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerCanChangeNumberOfVariations = () => {
  const currentCustomer = useCurrentCustomer();
  return customerCanChangeNumberOfVariations(currentCustomer);
};
